import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";
import { CallToActionContextType, useCallToActionContext } from "@contexts/CallToActionContext";
import { FontSize } from "@themes/Fonts";
import { UpgradeCTASource } from "@user/AmplitudeProSubsEvents";

const Indicator = styled.div`
    font-size: ${FontSize.normal};
`;

const IndicatorText = styled.span`
    text-decoration-line: underline;
`;

const READ_ONLY_LABEL = "read only";
const READ_ONLY_INFO_MSG = "Please upgrade to Pro to use this widget.";

interface ReadOnlyIndicatorProps {
    readonly widgetId: string;
    readonly className?: string;
}
function ReadOnlyIndicator(props: ReadOnlyIndicatorProps) {
    const { setUpgradeCtaContext }: CallToActionContextType = useCallToActionContext();

    return (
        <Indicator
            className={props.className}
            data-for={`read-only-${props.widgetId}-widget-indicator`}
            data-tip={READ_ONLY_INFO_MSG}
            onClick={setUpgradeContextForWidgetId}
        >
            <IndicatorText>{READ_ONLY_LABEL}</IndicatorText>
            <ReactTooltip id={`read-only-${props.widgetId}-widget-indicator`} />
        </Indicator>
    );

    /**
     * TODO: duplicated in WidgetTabHeader.tsx, consolidate at some point.
     * - create widgetId type instead of using string
     */
    function setUpgradeContextForWidgetId() {
        switch (props.widgetId) {
            case "notesData":
                setUpgradeCtaContext("readOnlyWidget", UpgradeCTASource.NOTES_WIDGET);
                break;
            default:
                setUpgradeCtaContext("readOnlyWidget", UpgradeCTASource.WIDGETS_GENERAL);
                break;
        }
    }
}

export default ReadOnlyIndicator;
